export enum ClientType {
  Company = 1,
  Individual = 2
}
